/**
 * Combine all reducers in this file and export the combined reducers.
 */
import workDaysReducer from "./reducers/workDaysReducer";

import paramAvantagesReducer from "./reducers/paramAvantagesReducer";
import attestationsReducer from "./reducers/attestationsReducer";
import campagnesReducer from "./reducers/campagnesReducer";
import leaveBalanceReducer from "./reducers/leaveBalanceReducer";
import { combineReducers } from 'redux';
import authReducer from './reducers/authReducer';
import userReducer from './reducers/userReducer';
import jobReducer from "./reducers/jobReducer";
import entiteReducer from "./reducers/entiteReducer";
import sidebarMenuReducer from "./reducers/sidebarMenuReducer";
import offboardingReducer from "./reducers/offboardingReducer";
import roleReducer from "./reducers/roleReducer";
import companyReducer from "./reducers/companyReducer";
import timesheetWorkflowReducer from "./reducers/timesheetWorkflowReducer";
import workflowValidationReducer from "./reducers/workflowValidationReducer";
import paramCongesReducer from "./reducers/paramCongesReducer";
import emailReducer from "./reducers/emailReducer";
import skillEvaluationReducer from "./reducers/skillEvaluationReducer";
import notificationSettingsReducer from "./reducers/notificationSettingsReducer";
import taskSettingsReducer from "./reducers/taskSettingsReducer";
import notificationReducer from "./reducers/notificationReducer";
import taskReducer from './reducers/taskReducer';

import chasseursReducer from "./reducers/chasseursReducer";
import partenairesAcademiquesReducer from "./reducers/partenairesAcademiquesReducer";
import etablissementsReducer from "./reducers/etablissementsReducer";
import candidatsReducer from "./reducers/candidatsReducer";

import payslipReducer from "./reducers/payslipReducer";

import leaveRequestsReducer from "./reducers/leaveRequestsReducer";
import leaveRequestReducer from "./reducers/leaveRequestsReducer";
import paramDomainesThemesReducer from "./reducers/paramDomainesThemesReducer";
import noteDeFraisReducer from "./reducers/noteDeFraisReducer";
import ordreMissionReducer from "./reducers/ordreMissionReducer";
import avanceReducer from "./reducers/avanceReducer";
import formationsReducer from "./reducers/formationsReducer";
import timesheetReducer from "./reducers/timesheetReducer";
import cataloguesReducer from "./reducers/cataloguesReducer";
import avanceRequestsReducer from "./reducers/avanceRequestReducer";
import missionRequestsReducer from "./reducers/missionRequestReducer";
import noteDeFraisRequestsReducer from "./reducers/noteDeFraisRequestReducer";
import mesAvantagesReducer from "./reducers/mesAvantagesReducer";
import avantageSocialRequestsReducer from "./reducers/avantageSocialRequestReducer";
import demandesReducer from "./reducers/demandesReducer";
import sallesReducer from "./reducers/sallesReducer";
import fournisseursReducer from "./reducers/fournisseursReducer";
import consultantsReducer from "./reducers/consultantsReducer";
import modulesCleReducer from "./reducers/modulesCleReducer";
import eventsReducer from "./reducers/eventsReducer";
import applicationLogReducer from "./reducers/applicationLogReducer";
import moduleReducer from "./reducers/moduleReducer";
import demandesRecrutementReducer from "./reducers/demandesRecrutementReducer";
import skillsReducer from "./reducers/skillsReducer";
import niveauSkillReducer from "./reducers/niveauSkillReducer";
import jobSkillReducer from "./reducers/jobSkillReducer";
import modeEvaluationReducer from "./reducers/modeEvaluationReducer";
import careerPathReducer from "./reducers/careerPathReducer";
import employeeCareerPathReducer from "./reducers/employeeCareerPathReducer";
import careerPathStepReducer from "./reducers/careerPathStepReducer";
import projetReducer from "./reducers/projetReducer";

import repertoireReducer from "./reducers/repertoireReducer";
import evaluationReducer from "./reducers/evaluationReducer";
import seuilPassageReducer from "./reducers/seuilPassageReducer";

export default function createReducer(injectedReducers = {}) {
    const rootReducer = combineReducers({
        // Reducers permanents (toujours actifs)
        projet: projetReducer,
        attestations:attestationsReducer,
        workDays:workDaysReducer,
        applicationLog: applicationLogReducer,
        campagnes:campagnesReducer,
        modulesCle: modulesCleReducer,
        module: moduleReducer,
        events: eventsReducer,
        repertoire: repertoireReducer,
        evaluations:evaluationReducer,
        paramAvantagessociaux : paramAvantagesReducer,
        jobSkill: jobSkillReducer,
        formations:formationsReducer,
        catalogues:cataloguesReducer,
        skills: skillsReducer,
        fournisseurs:fournisseursReducer,
        consultants:consultantsReducer,
        niveauSkill: niveauSkillReducer,
        salles:sallesReducer,
        emails: emailReducer,
        demandesRecrutement: demandesRecrutementReducer,
        auth: authReducer,
        mesAvantages:mesAvantagesReducer,
        avantageSocialRequests: avantageSocialRequestsReducer,
        missionRequests: missionRequestsReducer,
        noteDeFraisRequests: noteDeFraisRequestsReducer,
        careerPath: careerPathReducer,
        careerPathStep: careerPathStepReducer,
        employeeCareerPath: employeeCareerPathReducer,
        user: userReducer,
        timesheet: timesheetReducer,
        notification: notificationReducer,
        demandes:demandesReducer,
        jobs: jobReducer,
        timesheetWorkflow: timesheetWorkflowReducer,
        entite: entiteReducer,
        sidebarMenus: sidebarMenuReducer,
        modesEvaluation: modeEvaluationReducer,
        role:roleReducer,
        companies:companyReducer,
        payslips: payslipReducer,
        workflowValidation: workflowValidationReducer,
        paramConges: paramCongesReducer,
        leaveRequests: leaveRequestReducer,
        offboarding: offboardingReducer,
        paramDomainesThemes:paramDomainesThemesReducer,
        avance:avanceReducer,
        skillEvaluation: skillEvaluationReducer,
        seuilPassage: seuilPassageReducer,
        notificationSettings: notificationSettingsReducer,
        taskSettings: taskSettingsReducer,
        tasks: taskReducer,

        noteDeFrais:noteDeFraisReducer,
        ordreMission:ordreMissionReducer,
        avanceRequests: avanceRequestsReducer,
        leaveBalance: leaveBalanceReducer,
        chasseurs: chasseursReducer,
        partenairesAcademiques: partenairesAcademiquesReducer,
        etablissements: etablissementsReducer,
        candidats: candidatsReducer,
        // Reducers injectés dynamiquement
        ...injectedReducers,
    });

    return rootReducer;
}
